import { apiSlice } from "../../apiSlice";
import { Note } from "../../../types/modulesInterfaces";
export interface NotesCreatePayload {
	content: string | null;
	module_type_id?: number;
	module_id: number;
	project_id: number;
}

export interface NotesUpdatePayload {
	id: number;
	content: string | null;
	project_id: number;
}

export interface NotesDeletePayload {
	id: number;
}

// Re-export types from createGenericOperationsApi for backward compatibility
export type { GetDefaultProps, GetModuleTypesPayload } from "./createGenericOperationsApi";

// Create mutations API slice
const moduleResMutationApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		deleteModuleNotes: builder.mutation<Note, { id: number, project_id: number }>({
			query: ({ id }) => {
				return {
					url: `notes/${id}/`,
					method: "DELETE",
				}
			},
			invalidatesTags: (_result, _error, { project_id }) => [
				{ type: 'FastProjects', id: project_id },
				{ type: 'DetailedProjects', id: project_id }
			],
		}),
		createModuleNotes: builder.mutation<Note, NotesCreatePayload>({
			query: (body) => {
				return {
					url: "notes/",
					method: "POST",
					body,
				};
			},
			invalidatesTags: (_result, _error, { project_id }) => [
				{ type: 'DetailedProjects', id: project_id },
				{ type: 'FastProjects', id: project_id },
			],
		}),
		updateModuleNotes: builder.mutation<Note, NotesUpdatePayload>({
			query: ({ id, content }) => {
				return {
					url: `notes/${id}/`,
					method: "PATCH",
					body: { content }
				};
			},
			invalidatesTags: (_result, _error, { project_id }) => [
				{ type: 'DetailedProjects', id: project_id },
				{ type: 'FastProjects', id: project_id }
			],
		}),
	})
});

// Export mutation hooks
export const {
	useUpdateModuleNotesMutation,
	useCreateModuleNotesMutation,
	useDeleteModuleNotesMutation,
} = moduleResMutationApiSlice;

// Re-export query hooks from createGenericOperationsApi for backward compatibility
export {
	useGetModuleResultsByGasQuery,
	useGetModuleHistoryQuery,
	useGetSubmoduleDefaultsQuery,
	useGetModuleTypesQuery,
	useGetDefaultCountryQuery,
	useGetModuleByIdQuery,
} from "./createGenericOperationsApi";
